import PropTypes from 'prop-types';

import CategoryPriceSlider from 'Component/CategoryPriceSlider';
import ExpandableContent from 'Component/ExpandableContent';
import Field from 'Component/Field';
import ProductConfigurableAttributes from 'Component/ProductConfigurableAttributes/ProductConfigurableAttributes.component';
import { CategoryConfigurableAttributes as SourceCategoryConfigurableAttributes } from 'SourceComponent/CategoryConfigurableAttributes/CategoryConfigurableAttributes.component';
import { CategoryFragment } from 'Type/Category';

import { FILTERS_AMOUNT_TO_SHOW_SEARCHER } from './CategoryConfigurableAttributes.config';

import './CategoryConfigurableAttributes.override.style';

/** @namespace AdvoxBasic/Component/CategoryConfigurableAttributes/Component/CategoryConfigurableAttributes */
export class CategoryConfigurableAttributes extends SourceCategoryConfigurableAttributes {
    static propTypes = {
        ...super.propTypes,
        searchFilterValue: PropTypes.string,
        handleSearchFilterValueChange: PropTypes.func.isRequired,
        childrenCategories: PropTypes.arrayOf(PropTypes.shape(CategoryFragment)),
    };

    static defaultProps = {
        ...ProductConfigurableAttributes.defaultProps,
        searchFilterValue: '',
    };

    renderDropdownOrSwatch(option) {
        const { isContentExpanded, getSubHeading } = this.props;

        const { attribute_label, attribute_code, attribute_options } = option;

        const [{ swatch_data }] = attribute_options ? Object.values(attribute_options) : [{}];
        const isSwatch = !!swatch_data;

        return (
            <ExpandableContent
                key={attribute_code}
                heading={attribute_label}
                subHeading={getSubHeading(option)}
                mix={{
                    block: 'ProductConfigurableAttributes',
                    elem: 'Expandable',
                }}
                isContentExpanded={isContentExpanded}
                isArrow
                isExpandableOnDesktop
            >
                {isSwatch ? this.renderSwatch(option) : this.renderDropdown(option)}
            </ExpandableContent>
        );
    }

    renderPriceSwatch(option) {
        const { isContentExpanded, getSubHeading } = this.props;

        const { attribute_label, attribute_code, attribute_values } = option;

        const min = +attribute_values[0];
        const max = +attribute_values[1];

        return (
            <ExpandableContent
                key={attribute_code}
                heading={__(attribute_label)}
                subHeading={getSubHeading(option)}
                mix={{
                    block: 'ProductConfigurableAttributes',
                    elem: 'Expandable',
                }}
                isContentExpanded={isContentExpanded}
                isArrow
                isExpandableOnDesktop
            >
                <CategoryPriceSlider min={min} max={max} />
            </ExpandableContent>
        );
    }

    renderDropdown(option) {
        const { attribute_values, attribute_code, attribute_options } = option;
        const { searchFilterValue, handleSearchFilterValueChange } = this.props;

        const filterValue = searchFilterValue[attribute_code] || '';
        const attributeOptionsArray = Object.values(attribute_options);

        const attributeOptionsFiltered = attributeOptionsArray.filter((attr) =>
            attr.label.toLowerCase().includes(filterValue.toLowerCase())
        );
        const attributeValuesString = attributeOptionsFiltered.map((attr) => attr.value_string);
        const attributeValuesFiltered = attribute_values.filter((val) => attributeValuesString.includes(val));

        const showFilterSearcher = attribute_values && attribute_values.length >= FILTERS_AMOUNT_TO_SHOW_SEARCHER;
        return (
            <div block="ProductConfigurableAttributes" elem="DropDownList">
                {showFilterSearcher ? (
                    <div block="CategoryConfigurableAttributes" elem="FilterSearcher">
                        <Field
                            id="searchFilters"
                            type="search"
                            placeholder={__('Search')}
                            onChange={(value) => handleSearchFilterValueChange(value, attribute_code)}
                        />
                    </div>
                ) : null}

                <div block="CategoryConfigurableAttributes" elem="Attributes">
                    {attributeValuesFiltered.map((attribute_value) =>
                        this.renderConfigurableAttributeValue({ ...option, attribute_value })
                    )}
                </div>
            </div>
        );
    }

    renderConfigurableOption = (option) => {
        const { attribute_code } = option;

        switch (attribute_code) {
            case 'price':
                return this.renderPriceSwatch(option);
            case 'category_id':
                // categories are handles by CategoryTree component
                return null;
            default:
                return this.renderDropdownOrSwatch(option);
        }
    };
}

export default CategoryConfigurableAttributes;
